import Icon from "components/global/Icon";
import Text from "components/typography/Text";
import pseudoFormat from "utils/pseudoFormat";
import { useTranslation } from "react-i18next";

const AlbumLabel = ({
	private: isPrivate,
	name,
	amount,
	isEllipsis,
	color = "black",
	id = null,
}) => {
	const { t } = useTranslation(["userpanel"]);

	const finalName =
		id === "public"
			? t("userpanel:media:album:main")
			: id === "private"
			? t("userpanel:media:album:mainPrivate")
			: name;

	return isEllipsis ? (
		<Text
			style={{ display: "flex", maxWidth: "160px", whiteSpace: "nowrap" }}
		>
			{isPrivate ? (
				<Text block mr={1.75}>
					<Icon color={color}>lock</Icon>
				</Text>
			) : null}

			<Text
				pr={1}
				style={{
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}
			>
				{finalName}
			</Text>
			<Text bold>{pseudoFormat(amount)}</Text>
		</Text>
	) : (
		<Text style={{ display: "flex", overflowWrap: "anywhere" }}>
			{isPrivate ? (
				<Text block mr={1.75}>
					<Icon color={color}>lock</Icon>
				</Text>
			) : null}
			{amount ? (
				<Text block>
					{`${finalName} `}
					<Text bold>{pseudoFormat(amount)}</Text>
				</Text>
			) : (
				<Text block>{`${finalName}`}</Text>
			)}
		</Text>
	);
};

export default AlbumLabel;
